import dateformat from "dateformat";

export function toggleCode(e) {
  const card = e.target.closest(".card");
  const codeWrapper = card.querySelector(".code-wrapper");

  e.target.checked
    ? codeWrapper.classList.remove("hidden")
    : codeWrapper.classList.add("hidden");
}

export function getBrwoserScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
}

export function isNullEmptyOrWhiteSpace(value) {
    if (typeof value !== 'string' || value === null || value === undefined) {
        return true;
    }

    if (value.length == 0) {
        return true;
    }

    if (value.match(/^ *$/) !== null) {
        return true;
    }

    return false;
}

export function removeNodeById(id) {
    let node = document.querySelector(`#${id}`);

    if (node !== null && node !== undefined) {
        node.remove();
    }
}

export function getCurrentTheme() {
    let value = Alpine.store("global").isDarkModeEnabled;

    if (value !== null && value !== undefined) {
        return value;
    }

    return false;
}

export function switchCurrentTheme() {
    Alpine.store("global").isDarkModeEnabled = !(Alpine.store("global").isDarkModeEnabled);
}

export function applyTheme(isDarkMode) {
    Alpine.store("global").isDarkModeEnabled = isDarkMode;
}

export function applySystemTheme() {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        applyTheme(true);
    }
}

const ulidAlphabet = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

function dateFromUlid(ulid) {
    let timestamp = 0;
    const decodedTimestamp = ulid.substring(0, 10).toUpperCase();

    for (let i = 0; i < decodedTimestamp.length; i++) {
        const char = decodedTimestamp.charAt(i);
        const multiplier = ulidAlphabet.indexOf(char);
        const exponent = (9 - i);

        timestamp += (Math.pow(32, exponent)) * multiplier;
    }

    return new Date(timestamp);
}

export function extractDateFromTaskId(taskid) {
    const date = dateFromUlid(taskid.substring(26, 26 * 2));
    return dateformat(date, "dd/mm/yyyy HH:MM:ss 'UTC'");
}

export async function copyToClipboard(content) {
    try {
        await navigator.clipboard.writeText(content);

        return true;
    } catch (e) {
        return false;
    }
}

export function leaveAnimation(node, cb, leaveClass = "animate:leave") {
    const styles = window.getComputedStyle(node);
    if (styles.getPropertyValue("display") === "none") return;

    node.classList.add(leaveClass);

    setTimeout(() => {
        cb();
        node.classList.remove(leaveClass);
    }, 203);



    //node.addEventListener(
    //    "animationend",
    //    () => {
    //        console.warn("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF");
    //        cb();
    //        node.classList.remove(leaveClass);
    //    },
    //    { once: true }
    //);
}
